import { fetchContentApi } from '../../services/content-api'

export const apiFetchDevices = async (preSaleFlag, language, customer) => {
  const preSaleURL = preSaleFlag ? '&presales=1' : ''
  return fetchContentApi(`/phones?language=${language}&customer=${customer}${preSaleURL}`)
}



// WEBPACK FOOTER //
// ./src/containers/DeviceSelector/services.js